<div class="outer-container">
  <div class="container" *ngIf="card">
    <p class="svg-container">
      <button type="button" class="audio-buttons" (click)="play()" *ngIf="!isPlaying" #audioPlayButton>
        <svg-icon class="icon" src="/assets/icons/play-circle.svg"></svg-icon>
      </button>
      <button type="button" class="audio-buttons" (click)="pause()" *ngIf="isPlaying" #audioPauseButton>
        <svg-icon class="icon" src="/assets/icons/pause-circle.svg"></svg-icon>
      </button>

      <span *ngIf="isPlaying">{{ currentTime }}</span>
      <span *ngIf="!isPlaying">Listen</span>
      | {{ duration }}
    </p>
    <progress #progress value="{{ current }}" max="{{ dur }}" (click)="seek($event)"></progress>
  </div>

  <div class="audio-container">
    <audio
      controls
      #player
      preload="auto"
      (timeupdate)="updateTime()"
      (ended)="ended()"
      (loadedmetadata)="getDuration()"
      (play)="playStarted()"
      (pause)="paused()"
      (error)="onError()">
      <source src="{{ url }}" type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
  </div>
</div>
